'use client';

import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

export default function HubMeetupSliderFrame({
  slideKey,
  direction = 'next',
  className = '',
  children,
}) {
  const reduced = useReducedMotion();
  const offset = direction === 'prev' ? -88 : 88;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={slideKey}
        className={className}
        initial={{ opacity: 0, x: reduced ? 0 : offset }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: reduced ? 0 : offset * -0.55 }}
        transition={{
          duration: reduced ? 0.12 : 0.34,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
